export const isReadonlyChunk = (chunkId: string, type: server.dto.FormElementTypes) => (chunkId === "ShowEventDate" || chunkId === "ArtistName") || (type === "textReadOnly");
